import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { AbsoluteContainer, AppSpan, AppText, Button, CustomContainer, FixedContainer, FlexRow, GridContainer, SideBarContainer, SideBarShadow } from "src/style"
import { sideBarData } from './sidebarData'
import { SidebarMenu } from './sidebarMenu'
import { ReactComponent as Logo } from 'src/assets/img/crendly-logo-blue.svg'
import { HiOutlineQuestionMarkCircle } from 'react-icons/hi'
import { IoIosAdd } from 'react-icons/io'
import { NewCreation } from 'src/popup'
import { RiExternalLinkLine } from 'react-icons/ri'
import { IoLogOutOutline } from 'react-icons/io5'


export const Sidebar: React.FC = () => {
    const navigate = useNavigate()
    const {visibility, showSideBar} = useContext(VisibilityContext)
    const {logout} = useContext(AppInfoContext)
    const [isNewCreation, setIsNewCreation] = useState(false)

    return (
        <>
            {/* <SideBarShadow isSideBar={visibility.isSideBar} onClick={() => showSideBar(false)}/> */}
            <SideBarContainer isSideBar={visibility.isSideBar}>
                <AbsoluteContainer top='0' left='0.5' className='logo-dashboard'>
                    <Logo />
                </AbsoluteContainer>
                <AbsoluteContainer bottom='5' left='0.5' className='logo-dashboard'>
                    <HiOutlineQuestionMarkCircle className='question-icon' />
                </AbsoluteContainer>
                <CustomContainer 
                    height='100' hUnit='%' leftPadding='1.4'
                    style={{borderLeft: '1px solid #E2E8F0'}}
                >
                    <AppText 
                        textSize='1.1' fontWeight='600' topMargin='3'
                        bottomMargin='3' leftMargin='3'
                    >
                        CUSTOMER SUPPORT
                    </AppText>
                    {
                        sideBarData.map((menu, index) => {
                            return <SidebarMenu item={menu} key={index} />
                        })
                    }
                    <AbsoluteContainer bottom='10' left='2' onClick={() => setIsNewCreation(true)}>
                        <GridContainer
                            width='4.6' height='4.6' radius='0.8' bgColor='#4C6FFF'
                        >
                            <IoIosAdd style={{color: '#ffffff', fontSize: '1.8rem'}} />
                        </GridContainer>
                    </AbsoluteContainer>
                    <AbsoluteContainer width='100' sizeUnit='%' bottom='3'>
                        <Button 
                            width='14' borderColor='#4C6FFF' height='3.6'
                            hoverBgColor='#E1E8FF' hoverBorderColor='#E1E8FF' titleSize='1.4'
                            bgColor='transparent' color='#4C6FFF' leftMargin='1.5'
                            onClick={logout}
                        >
                            <IoLogOutOutline style={{fontSize: '1.8rem', marginRight: '1rem'}} /> 
                            Logout
                        </Button>
                    </AbsoluteContainer>
                </CustomContainer>
            </SideBarContainer>
            { isNewCreation &&
                <NewCreation 
                    close={() => setIsNewCreation(false)}
                />
            }
        </>
    )
}